/* istanbul ignore next */
export const HOME_EXCLUDED_PATHS = [
  "/prime-refer-a-friend/",
  "/prime-parrainer-un-ami/",
  "/prime-invita-un-amigo/",
  "/prime-invita-un-amico/",
  "/prime-indique-um-amigo/",
  "/prime-einem-freund-empfehlen/",
  "/prime-aanbevelen-aan-een-vriend/",
  "/referrals/",
  "/parrainages/",
  "/recomendaciones/",
  "/raccomandazioni/",
  "/referencias/",
  "/empfehlungen/",
  "/aanbevelingen-prime/",
];
export const GOT_ID = "got";
